import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Layer = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M3.533 11.119l7.295 5.274c.343.245.748.374 1.172.374s.829-.129 1.176-.377l7.292-5.272a2.002 2.002 0 0 0-.002-3.238l-7.294-5.273a2.049 2.049 0 0 0-2.348.003L3.532 7.882c-.516.375-.824.979-.824 1.618s.308 1.243.825 1.619zm8.471-6.889l7.289 5.27-7.284 5.267-.009.001-.004.002-7.29-5.269 7.298-5.271z", key: "k0" }),
        React.createElement("path", { d: "M19.329 14.723l-7.335 5.275-7.23-5.204L3.07 16.04l7.758 5.583a2.017 2.017 0 0 0 2.346-.002l7.872-5.665-1.717-1.233z", key: "k1" })));
});
Layer.displayName = 'Layer';
export var LayerDimensions = { height: 24, width: 24 };
